import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SharedFormsModule } from '@app-shared/forms/shared-forms.module';

import { DialogNewExpertComponent } from './dialog-new-expert.component';
import { SharedComponentsModule } from '../shared-components.module';
import { MatSelectModule } from '@angular/material/select';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { MatRadioModule } from '@angular/material/radio';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    DialogNewExpertComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    MatAutocompleteModule,
    SharedFormsModule,
    SharedComponentsModule,
    NgxMatSelectSearchModule,
    CurrencyMaskModule,
    NgxDropzoneModule,
    NgxMaskDirective,
    NgxMaskPipe
  ],
})
export class DialogNewExpertModule {}
